<script>
  import CarouselScroller from "./CarouselScroller.svelte";
  import Card from "./CarouselCard.svelte";

  let { cards } = $props();

  let randomEmptyStateText = [
    "Nothing to see yet!",
    "Nothing to see at the moment.",
    "Stay tuned for updates!",
    "Check back later for new listings.",
  ].sort(() => Math.random() - 0.5)[0];
</script>

<CarouselScroller>
  {#if cards.length <= 0}
    <div
      class="tw:group/card tw:relative tw:isolate tw:mx-auto tw:flex tw:h-40 tw:w-3/4 tw:shrink-0 tw:snap-center tw:flex-row tw:items-center tw:justify-center tw:text-center tw:text-2xl tw:text-zinc-500 tw:transition-colors tw:select-none"
    >
      {randomEmptyStateText}
    </div>
  {/if}
  {#each cards as card}
    <Card
      title={card.title}
      image_url={card.image_url}
      icon={card.default_icon}
      status={card.status}
    >
      {#if card.content}
        <p class="tw:line-clamp-4 tw:truncate tw:text-pretty">
          {@html card.content}
        </p>
      {/if}

      {#snippet subtitle()}
        {@html card.subtitle}
      {/snippet}

      {#snippet default_icon(icon)}
        {#if icon}
          {@html icon}
        {:else}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke-width="1.5"
            stroke="currentColor"
            class="tw:size-20 tw:text-zinc-300"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"
            />
          </svg>
        {/if}
      {/snippet}

      {#snippet action()}
        {#if card.url}
          <div
            class="tw:absolute tw:top-2 tw:right-2 tw:rounded-full tw:p-1 tw:ring-2 tw:ring-zinc-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              fill="currentColor"
              class="tw:size-4 tw:text-primary tw:transition-all tw:group-hover/card:scale-115"
            >
              <path
                fill-rule="evenodd"
                d="M4.22 11.78a.75.75 0 0 1 0-1.06L9.44 5.5H5.75a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-5.22 5.22a.75.75 0 0 1-1.06 0Z"
                clip-rule="evenodd"
              />
            </svg>
          </div>
          <a
            href={card.url}
            class="focus:tw:outline-none tw:absolute tw:inset-0"
            aria-label={`Connect with ${card.title}`}
            target="_blank"
          ></a>
        {:else}
          {@html card.action}
        {/if}
      {/snippet}
    </Card>
  {/each}
</CarouselScroller>
